import { useMemo, useState } from "react";
import { useGetSchoolCandidateLastBatchStatusQuery } from "../../../queries";
import { BatchStatusEnum } from "../../../models";

interface IProps {
  selectedCountyId: number | undefined;
  countyIds: number[];
}

export const useBatchManagement = ({ selectedCountyId, countyIds }: IProps) => {
  const { data: lastBatchStatuses } = useGetSchoolCandidateLastBatchStatusQuery(
    countyIds,
    {
      skip: !countyIds.length,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }
  );

  const [selectedBatchId, setSelectedBatchId] = useState<number | null>(null);

  const selectedBatchStatus = useMemo(() => {
    const batchStatus = lastBatchStatuses?.find(
      (status) => status.countyId === selectedCountyId
    );

    if (batchStatus) {
      setSelectedBatchId(batchStatus.batchId);
    }

    return batchStatus;
  }, [lastBatchStatuses, selectedCountyId]);

  const isAddressPickupInProgress =
    selectedBatchStatus?.status === BatchStatusEnum.InProgress;

  const isStartAddressPickupLastBatchDisabled = (() => {
    if (!selectedCountyId) return true;

    return isAddressPickupInProgress;
  })();

  return {
    selectedBatchStatus,
    isStartAddressPickupLastBatchDisabled,
    isAddressPickupInProgress,
    selectedBatchId,
    setSelectedBatchId,
  };
};
